// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2zvAe","label":"Section_label__2XgwK","contentWrap":"Section_contentWrap__2TfGO","footer":"Section_footer__3dSI8","footerInner":"Section_footerInner__1rzM6"};